import Axios from "axios";

const endpoint = `https://ipgeolocation.abstractapi.com/v1/?api_key=${process.env.REACT_APP_ABSTRACT_API_KEY}`;

const axios = Axios.create({
  timeout: 5000,
});

export const getGeoLocation = async () => axios.get(endpoint);
